import React, { Fragment, useMemo, useState } from "react";
import { BsChevronDown, BsChevronRight } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "../static/img/icon.svg";
import Logo from "../static/img/logo.svg";
import "./admin-menu.scss";

export function AdminMenu(props) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [expandedItemId, setExpandedItemId] = useState("");

  React.useEffect(() => {
    let adminBubbles = document.getElementsByClassName(
      "user-icon-wrapper__image-circle"
    );
    for (let i = 0; i < adminBubbles.length; i++) {
      adminBubbles[i].style.backgroundColor = "#DEE7EE";
    }
    for (let i = 0; i < props.whosLoggedIn.length; i++) {
      if (props.whosLoggedIn[i].user) {
        // document.getElementById(
        //   `${props.whosLoggedIn[i].user
        //     .replace(/\s/g, "")
        //     .toLowerCase()}-online-icon-circle`
        // ).style.backgroundColor = "green";
      }
    }
  }, [props.whosLoggedIn]);

  const nav = useNavigate();

  const onClickItem = (parentRoute, childRoute) => {
    if (parentRoute.externalLink) {
      return window.open(parentRoute.externalLink, "_blank", "noreferrer");
    }
    if (parentRoute.children && !childRoute)
      setExpandedItemId(
        expandedItemId === parentRoute.path ? "" : parentRoute.path
      );
    else {
      const navPath = `${parentRoute.path}${
        !!childRoute ? `/${childRoute.path}` : ""
      }`;
      nav(navPath);
    }
  };

  const isInDevMode = () => {
    if(window.location.origin === "http://localhost:3000") {
      return true
    }
    if(window.location.origin === "https://dev.atharo.app") {
      return true
    }
    if(window.location.origin === "https://app.atharo.app") {
      return false
    }
  }

  const location = useLocation();

  const chevronProps = {
    color: "inherit",
    size: 15,
  };

  const menuRoutes = useMemo(
    () =>
      props.routes
        .filter((route) => !!route.label && !!route.sortOrder)
        .sort((a, b) => a.sortOrder - b.sortOrder),
    [props.routes]
  );

  const isActive = (path) => {
    const locationArray = location.pathname.split("/");
    return locationArray[2] === path;
  };

  const user = useMemo(() => props?.userData, [props?.userData]);

  return (
    <div
      className={`admin-dashboard-menu ${
        menuOpen && "admin-dashboard-menu--open"
      }`}
      id="admin-dashboard-menu"
      onMouseEnter={() => setMenuOpen(true)}
      onMouseLeave={() => setMenuOpen(false)}
    >
      {isInDevMode() && <div className="menu-header__dev-env">DEV ENV</div>}
      <div className="admin-dashboard-menu-top">
        <div className="menu-header">
          <img alt="new-atharo-icon" src={Icon} className="menu-icon" />
          {menuOpen && (
            <img alt="new-atharo-logo" src={Logo} className="menu-logo" />
          )}
        </div>
        {menuRoutes.map((route, i) => {
          const isExpaned = expandedItemId === route.path;
          return (
            <Fragment key={i}>
              <div
                className={`admin-menu-item-wrapper ${
                  isActive(route.path) && "admin-menu-item-wrapper--active"
                }`}
                id={`wrapper-${route.path}`}
              >
                <div
                  className="flex items-center justify-between"
                  onClick={() => onClickItem(route)}
                >
                  <div
                    className={`admin-menu-item ${
                      location.pathname.indexOf(route.path) === 5 &&
                      "admin-menu-item--active"
                    }`}
                  >
                    {route.icon} {route.label}
                  </div>
                  {route.children ? (
                    isExpaned ? (
                      <BsChevronDown {...chevronProps} />
                    ) : (
                      <BsChevronRight {...chevronProps} />
                    )
                  ) : (
                    <></>
                  )}
                </div>
                {route.children && (
                  <div
                    className={`admin-menu-item-children ${
                      isExpaned && "admin-menu-item-children--open"
                    }`}
                  >
                    {route.children.map((child) => (
                      <div
                        className="admin-menu-item-wrapper internal"
                        id={`wrapper-${route.path}-${child.id}`}
                        key={`${route.path}-${child.id}`}
                        onClick={(e) => onClickItem(route, child)}
                      >
                        <div
                          id={child.id}
                          to={child.path}
                          className="admin-menu-item pl-8"
                        >
                          {child.label}{" "}
                          {child.counter && (
                            <div className="text-red-500 ml-2 text-xs">
                              {child.counterData}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Fragment>
          );
        })}
      </div>
      <div className="admin-menu-user-info">
        <img
          src={`https://app.atharo.app/${user?.ImageName}`}
          alt=""
          className="admin-menu-user-info-photo"
        />
        <div className="admin-menu-user-info-text">
          <div className="admin-menu-user-info-name">{user?.Name}</div>
          <div className="admin-menu-user-info-email">{user?.Email}</div>
        </div>
      </div>
    </div>
  );
}
